import { createSlice } from "@reduxjs/toolkit";
import { WebhookLibraryNetworkActions } from "./webhookLibrary.actions";

interface WebhookLibraryState {
  webhookList: any[];
  pagination: {
    totalRecords: number;
    totalPages: number;
  };
  contactOption: any[];
  webhookOptions: any[];
  loading: boolean;
  error: string | null;
}

const initialState: WebhookLibraryState = {
  webhookList: [],
  pagination: {
    totalRecords: 0,
    totalPages: 0,
  },
  contactOption: [],
  webhookOptions: [],
  loading: false,
  error: null,
};

const webhookLibrarySlice = createSlice({
  name: "webhookLibrary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //* getWebhookList
      .addCase(WebhookLibraryNetworkActions.getWebhookList.pending, (state) => {
        state.loading = true;  // Set loading to true when the request is pending
        state.error = null;    // Reset error when the request starts
      })
      .addCase(WebhookLibraryNetworkActions.getWebhookList.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when the request is fulfilled
        state.webhookList = action?.payload?.data?.data || []; // Safely update the webhook list
        state.pagination = action?.payload?.data?.pagination || { totalRecords: 0, totalPages: 0 }; // Safely update pagination
      })
      .addCase(WebhookLibraryNetworkActions.getWebhookList.rejected, (state, action) => {
        state.loading = false; // Set loading to false when the request is rejected
        state.error = action?.error?.message || "Error fetching webhook list"; // Set error message if request fails
      })

      //* getContactProperties
      .addCase(WebhookLibraryNetworkActions.getContactProperties.pending, (state) => {
        state.loading = true;  // Set loading to true when the request is pending
        state.error = null;    // Reset error when the request starts
      })
      .addCase(WebhookLibraryNetworkActions.getContactProperties.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when the request is fulfilled
        state.contactOption = action?.payload?.data?.data || []; // Safely update contact options
      })
      .addCase(WebhookLibraryNetworkActions.getContactProperties.rejected, (state, action) => {
        state.loading = false; // Set loading to false when the request is rejected
        state.error = action?.error?.message || "Error fetching contact properties"; // Set error message if request fails
      });
  },
});

export default webhookLibrarySlice.reducer;
